// extracted by mini-css-extract-plugin
export default {"container":"t2-z","heading":"u2-z","links":"v2-z","copy":"w2-z","subCopy":"x2-z","linksLeft":"y2-z","linksCenter":"z2-z","linksRight":"A2-z","link":"B2-z","onlyLink":"C2-z"};